import React, { FC, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import DebouncedTextField from "../../../components/DebouncedTextField";
import useAssessmentLabel from "../../../hooks/useAssessmentLabel";

// @ts-expect-error - css
import styles from "../Assessment.module.css";

interface AdviceInterface {
  advice: string;
  onChange: (value: string) => void;
}

export const MAX_LENGTH = 255;

const Advice: FC<AdviceInterface> = ({ advice, onChange }) => {
  const assessmentLabels = useAssessmentLabel();
  const [localValue, setLocalValue] = React.useState(advice || "");

  useEffect(() => {
    setLocalValue(advice || "");
  }, [advice]);

  return (
    <>
      <Box className={styles.assessmentRow} height="auto">
        <Box className={styles.assessmentLabel}>
          <Typography component="span" fontWeight="600">
            {assessmentLabels.advice}
          </Typography>
        </Box>
        <Box className={styles.assessmentField}>
          <DebouncedTextField
            margin="dense"
            id="outlined-basic"
            data-testmation="adviceTextField"
            fullWidth
            multiline
            variant="outlined"
            minRows={3}
            maxRows={3}
            placeholder="Type your advice here"
            value={localValue}
            slotProps={{
              inputLabel: { shrink: true }
            }}
            onChange={(e) => {
              setLocalValue(e.target.value);
              onChange(e.target.value);
            }}
            debounceAt={400}
          />
        </Box>
      </Box>
    </>
  );
};

export default Advice;
